import axios from 'axios';
import BaseComponent from 'scripts/BaseComponent.js';

export default class Filter extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      filterOption: '.js-filterOption',
      productGrid: '.js-productGrid',
      activeFiltersContainer: '.js-activeFiltersContainer',
      paginationContainer: '.js-paginationContainer',
      resultsCount: '.js-resultsCount',
      activeFilterCount: '.js-activeFilterCount',
      activeFiltersWrap: '.js-activeFiltersWrap',
      filterOptionsCount: '.js-filterOptionCount',
    };

    this.dom = {
      $component: component,
      $filterOptions: this.$getAll(this.refs.filterOption),
      $productGrid: document.querySelector(this.refs.productGrid),
      $activeFiltersContainer: document.querySelector(this.refs.activeFiltersContainer),
      $paginationContainer: document.querySelector(this.refs.paginationContainer),
      $resultsCount: document.querySelectorAll(this.refs.resultsCount),
      $activeFilterCount: this.$get(this.refs.activeFilterCount),
      $activeFiltersWrap: document.querySelector(this.refs.activeFiltersWrap),
      $filterOptionCounts: this.$getAll(this.refs.filterOptionsCount),
    };

    this.state = {
      baseURL: '',
      activeSearch: null,
      activeFilters: [],
      activeSort: '',
      clearFilterEvent: 'clearfilter',
      removeFilterEvent: 'removefilter',
      setPriceFiltersEvent: 'setpricefilters',
      resetPriceFilterEvent: 'resetpricefilter',
      updatePriceFilterEvent: 'updatepricefilters',
      updateSortEvent: 'updatesort',
      mountProductsEvent: 'mountproductcards',
      mountActiveFiltersEvent: 'mountactivefilters',
      mountVideosEvent: 'mountvideos',
      updateCoastFilterEvent: 'updatecoastfilter',
      hideActiveFiltersClass: 'hide-active-filters',
    };

    this.mount();
    this.init();
  }

  mount() {
    const { dom, state } = this;
    super.mount();

    this.setOnEventWithElement('change', dom.$filterOptions, this.filterClick);
    this.setOnCustomEvent(state.clearFilterEvent, this.clearFilter);
    this.setOnCustomEvent(state.removeFilterEvent, this.removeFilter);
    this.setOnCustomEvent(state.setPriceFiltersEvent, this.setPriceFilters);
    this.setOnCustomEvent(state.resetPriceFilterEvent, this.resetPriceFilter);
    this.setOnCustomEvent(state.updateSortEvent, this.updateSort);
    this.setOnCustomEvent(state.updateCoastFilterEvent, this.updateCoastFilter);
    window.addEventListener('popstate', this.popState.bind(this));
  }

  init() {
    this.setActives();
  }

  setActives() {
    const { state } = this;
    const url = new URL(document.location);

    state.baseURL = url.pathname;

    if (state.baseURL === '/search') {
      state.activeSearch = url.searchParams.get('q');
    }

    state.activeFilters = [];
    url.searchParams.forEach((value, name) => {
      if (name.includes('filter')) {
        state.activeFilters.push({ name, value });
      }
    });

    state.activeSort = url.searchParams.get('sort_by') || '';
  }

  filterClick(checkbox) {
    const { state } = this;
    const { name, value } = checkbox;
    const roseColorOptionName = 'filter.v.option.floral color';
    const index = state.activeFilters
      .findIndex((filter) => filter.name === name && filter.value === value);
    const roseColorIndex = state.activeFilters
      .findIndex((filter) => filter.name === roseColorOptionName);

    if (index > -1) {
      state.activeFilters.splice(index, 1);
    } else if (name === roseColorOptionName && roseColorIndex > -1) {
      this.removeActiveColorFilter(state.activeFilters[roseColorIndex]);
      state.activeFilters[roseColorIndex].value = value;
    } else {
      state.activeFilters.push({ name, value });
    }

    this.updateFilterCount();
    this.updateOptionsCount();
    this.pushToHistory();
    this.getFilterResults();
  }

  updateCoastFilter({ detail: { coast } }) {
    const { state } = this;
    const name = 'filter.p.m.custom.concierge_coast';

    const index = state.activeFilters
      .findIndex((filter) => filter.name === name);

    if (index > -1) {
      state.activeFilters[index].value = coast;
    } else {
      state.activeFilters.push({
        name,
        value: coast,
      });
    }

    this.updateFilterCount();
    this.updateOptionsCount();
    this.pushToHistory();
    this.getFilterResults();
  }

  removeFilter({ detail: { name, value } }) {
    const { state, refs } = this;

    state.activeFilters = state.activeFilters
      .filter((filter) => !(filter.name === name && filter.value === value));

    const checkboxSelector = `${refs.filterOption}[name="${name}"][value="${value}"]`;
    const checkbox = this.$get(checkboxSelector);
    checkbox.checked = false;

    this.updateActiveFiltersWrap();
    this.updateFilterCount();
    this.updateOptionsCount();
    this.pushToHistory();
    this.getFilterResults();
  }

  removeActiveColorFilter({ name, value }) {
    const { refs } = this;
    const checkboxSelector = `${refs.filterOption}[name="${name}"][value="${value}"]`;
    this.$get(checkboxSelector).checked = false;
  }

  setPriceFilters({ detail: { priceFilters } }) {
    const { state } = this;

    state.activeFilters = state.activeFilters
      .filter((filter) => !filter.name.includes('price'))
      .concat(priceFilters);

    this.updateFilterCount();
    this.pushToHistory();
    this.getFilterResults();
  }

  resetPriceFilter() {
    const { state } = this;

    state.activeFilters = state.activeFilters
      .filter((filter) => !filter.name.includes('price'));

    this.dispatch(state.updatePriceFilterEvent, {});
    this.updateActiveFiltersWrap();
    this.updateFilterCount();
    this.pushToHistory();
    this.getFilterResults();
  }

  clearFilter() {
    const { dom, state } = this;

    const coastOptionName = 'filter.p.m.custom.concierge_coast';
    const coastFilter = state.activeFilters.find(({ name }) => coastOptionName === name);

    state.activeFilters = [];
    if (coastFilter) {
      state.activeFilters.push(coastFilter);
    }

    dom.$filterOptions.forEach((checkbox) => { checkbox.checked = false; });

    this.dispatch(state.updatePriceFilterEvent, {});
    this.updateActiveFiltersWrap();
    this.updateFilterCount();
    this.updateOptionsCount();
    this.pushToHistory();
    this.getFilterResults();
  }

  updateSort({ detail: { value } }) {
    const { state } = this;
    state.activeSort = value;
    window.location.href = this.getFilteredURL();
  }

  async getFilterResults(page = 1) {
    const { dom, state, refs } = this;
    let url = this.getFilteredURL();

    if (page > 1) {
      url += url.includes('?') ? '&' : '?';
      url += `page=${page}`;
    }

    try {
      const { data } = await axios.get(url);
      const parser = new DOMParser();
      const results = parser.parseFromString(data, 'text/html');

      const resultsProductGrid = results.querySelector(refs.productGrid);
      const resultsActiveFiltersContainer = results.querySelector(refs.activeFiltersContainer);
      const resultsPaginationContainer = results.querySelector(refs.paginationContainer);
      const resultsResultsCount = results.querySelector(refs.resultsCount);

      dom.$productGrid.innerHTML = resultsProductGrid.innerHTML;
      dom.$activeFiltersContainer.innerHTML = resultsActiveFiltersContainer.innerHTML;
      dom.$paginationContainer.innerHTML = resultsPaginationContainer.innerHTML;
      dom.$resultsCount
        .forEach((count) => { count.textContent = resultsResultsCount.textContent; });

      this.dispatch(state.mountProductsEvent);
      this.dispatch(state.mountActiveFiltersEvent);
      this.dispatch(state.mountVideosEvent);
      this.updateActiveFiltersWrap();
      // eslint-disable-next-line no-underscore-dangle
      window._swat.initializeActionButtons(refs.productGrid);
    } catch (e) {
      console.log('Error getting filtered results', e);
    }
  }

  updateFilterCount() {
    const { dom, state } = this;
    const activeFiltersCount = state.activeFilters
      .filter(({ name }) => !name.includes('filter.v.price'))
      .length;

    dom.$activeFilterCount.textContent = activeFiltersCount > 0 ? `(${activeFiltersCount})` : '';
  }

  updateOptionsCount() {
    const { dom, state } = this;
    const optionsCount = {};

    state.activeFilters.forEach(({ name }) => {
      optionsCount[name] = optionsCount[name] + 1 || 1;
    });

    dom.$filterOptionCounts.forEach((filterOptionCount) => {
      const { param } = filterOptionCount.dataset;
      const count = optionsCount[param] || 0;
      filterOptionCount.textContent = count > 0 ? `(${count})` : '';
    });
  }

  updateActiveFiltersWrap() {
    const { dom, state } = this;
    const filterCountArr = state.activeFilters
      .filter(({ name }) => name !== 'filter.p.m.custom.concierge_coast');

    if (filterCountArr.length > 0) {
      dom.$activeFiltersWrap.classList.remove(state.hideActiveFiltersClass);
    } else {
      dom.$activeFiltersWrap.classList.add(state.hideActiveFiltersClass);
    }
  }

  getFilteredURL() {
    const { state } = this;
    const urlArr = [];
    let url = '';

    if (state.activeSearch) {
      urlArr.push('type=product');
      urlArr.push(`q=${state.activeSearch}`);
    }

    if (state.activeFilters.length) {
      state.activeFilters.forEach(({ name, value }) => urlArr.push(`${name}=${encodeURIComponent(value)}`));
    }

    if (state.activeSort) {
      urlArr.push(`sort_by=${state.activeSort}`);
    }

    url = urlArr.join('&');

    return url ? `${state.baseURL}?${url}` : state.baseURL;
  }

  pushToHistory() {
    const { state: { activeFilters } } = this;
    const url = this.getFilteredURL();
    window.history.pushState({ activeFilters }, '', url);
  }

  popState(e) {
    const { state } = this;
    const { searchParams } = new URL(document.location);
    const page = parseInt(searchParams.get('page'), 10) || 1;

    if (e.state) {
      state.activeFilters = e.state.activeFilters;
    } else {
      this.setActives();
    }

    this.checkActiveFilterBoxes();
    this.checkPriceSlider();
    this.updateFilterCount();
    this.updateOptionsCount();
    this.getFilterResults(page);
  }

  checkActiveFilterBoxes() {
    const { dom, state } = this;

    dom.$filterOptions.forEach((checkbox) => {
      const { name, value } = checkbox;
      const index = state.activeFilters
        .findIndex((filter) => filter.name === name && filter.value === value);

      if (index > -1) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });
  }

  checkPriceSlider() {
    const { state } = this;
    const priceFilters = {};
    const gteFilter = state.activeFilters.find(({ name }) => name === 'filter.v.price.gte');
    const lteFilter = state.activeFilters.find(({ name }) => name === 'filter.v.price.lte');

    if (gteFilter) priceFilters.start = gteFilter.value;
    if (lteFilter) priceFilters.end = lteFilter.value;
    this.dispatch(state.updatePriceFilterEvent, priceFilters);
  }
}
